import React from 'react';

import { useWindowDimensions } from 'react-native';

import Modal from 'components/modal';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { routes } from 'utils/routing';

import { ADDRESS_MODAL_MAX_WIDTH_DESKTOP } from './constants';
import { DeliveryAddressContainer } from './delivery-address-container';

export const DeliveryAddressModal: React.FC<React.PropsWithChildren> = () => {
  const { height } = useWindowDimensions();
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  const { navigate } = useNavigation();

  const handleDismiss = () => {
    navigate(routes.storeLocator);
  };

  return (
    <Modal
      backgroundColor={Styles.color.background}
      onDismiss={handleDismiss}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Select your delivery address',
      }}
      height={`${height}`}
      skipLoggingHeaderAndMessage={true}
      testID="delivery-modal"
      isDismissButtonAbsolute={isDesktopWeb}
      body={<DeliveryAddressContainer />}
      {...(isDesktopWeb && {
        contentStyle: { margin: '20px', maxWidth: ADDRESS_MODAL_MAX_WIDTH_DESKTOP },
      })}
    />
  );
};
